import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Trending from "./components/Trending";
import TimelineBoard from "./components/TimelineBoard";
import Categories from "./components/Categories";
import About from "./components/About";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";
import BackToTop from "./components/BackToTop";

const faqData = [
  {
    q: "吃瓜时间线到底是什么？",
    a: "吃瓜时间线是一个专注于热点事件梳理的资讯平台。我们会把每起正在发酵或已经尘埃落定的热门事件，从爆发、发酵、高潮到反转的关键节点，按时间顺序整理成一条清晰完整的时间线，让你花几分钟就能补全事件始末。",
  },
  {
    q: "时间线里的信息从哪里来？",
    a: "我们的内容以各事件的公开报道、当事方声明和权威媒体信息为基础进行二次梳理，每条时间线都会尽量标注关键节点的时间与信息来源倾向。",
  },
  {
    q: "为什么有些事件标着「发酵中」？",
    a: "标「发酵中」的事件意味着各方说法尚未完全一致、仍有新进展在持续出现，我们会持续跟踪并及时补充新节点。",
  },
];

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      {/* SEO JSON-LD 结构化数据 */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify([
            {
              "@context": "https://schema.org",
              "@type": "Organization",
              name: "吃瓜时间线",
              description: "专注于热点事件全记录梳理，整理爆发到反转的完整事件时间线。",
              url: typeof window !== "undefined" ? window.location.origin : "/",
            },
            {
              "@context": "https://schema.org",
              "@type": "WebSite",
              name: "吃瓜时间线",
              description: "热点事件时间线聚合资讯平台，帮你看懂每起事件的完整始末。",
              url: typeof window !== "undefined" ? window.location.origin : "/",
              inLanguage: "zh-CN",
            },
            {
              "@context": "https://schema.org",
              "@type": "FAQPage",
              mainEntity: faqData.map((f) => ({
                "@type": "Question",
                name: f.q,
                acceptedAnswer: { "@type": "Answer", text: f.a },
              })),
            },
          ]),
        }}
      />

      <Navbar />
      <main>
        <Hero />
        <Trending />
        <TimelineBoard />
        <Categories />
        <About />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
      <BackToTop />
    </div>
  );
}